// 테넌트 ID별 주차 레이아웃 로더
// 새 테넌트 추가 시: layout_TENANT_ID.js 파일 추가 후 이 파일에 case 추가

import defaultLayout from './layout_default';
import adria01Layout from './layout_ADRIA_01';
import adria2Layout  from './layout_adria2';

export function getLayout(tenantId) {
  switch (tenantId) {
    case 'ADRIA_01': return adria01Layout;
    case 'adria2':   return adria2Layout;
    default:         return defaultLayout;
  }
}
